import { useState, useEffect } from 'react';
import useStore from '../store/useStore';
import * as db from '../db';

// my_campuses() for the signed-in user, shared by the Topbar, the Dashboard and Users & Roles.
// One request per user and active campus; a failed request counts as "no extra campuses", so a
// single-campus school looks exactly as it always did.
let cache = { userId: null, schoolId: null, promise: null };

export default function useCampuses() {
  const userId = useStore(s => s.user?.id);
  const schoolId = useStore(s => s.user?.schoolId);
  const [state, setState] = useState({ rows: [], loading: !!userId });

  useEffect(() => {
    if (!userId) { setState({ rows: [], loading: false }); return undefined; }
    let cancelled = false;
    if (cache.userId !== userId || cache.schoolId !== schoolId || !cache.promise) {
      cache = {
        userId, schoolId,
        promise: db.getMyCampuses()
          .then(r => (Array.isArray(r) ? r : []))
          .catch(e => { console.warn('my_campuses unavailable:', e && e.message); return []; }),
      };
    }
    cache.promise.then(rows => { if (!cancelled) setState({ rows, loading: false }); });
    return () => { cancelled = true; };
  }, [userId, schoolId]);

  const rows = state.rows;
  const active = rows.find(r => r.is_active) || rows.find(r => r.school_id === schoolId) || null;
  const orgId = active ? active.organization_id : null;
  // Campuses of the organization the user is currently in (a school with no organization is alone)
  const orgCampuses = active ? (orgId ? rows.filter(r => r.organization_id === orgId) : [active]) : [];

  return { campuses: rows, active, orgId, orgCampuses, loading: state.loading, multi: orgCampuses.length >= 2 };
}
